import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  requiredError: 'Please enter a Workstation ID.',
  maxLengthExceededError: 'Workstation ID must not exceed 50 characters.',
})
